import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { endpoints } from "./apiConfig";
import { getAuthHeader } from "./session";

// Settings flags for the Waiter / Kitchen screens, polled every 30 seconds and whenever the window regains focus:
//  - clock: is a linked employee clocked out while the restaurant requires clock-in (view-only mode)?
//  - clockButton: info for the always-visible "Clock in / out" button (Employee module on)
//  - onlineEnabled: does the restaurant take online orders (shows the Online orders tab)?
export default function useClockState() {
  const [clock, setClock] = useState(null);
  const [clockButton, setClockButton] = useState(null);
  const [onlineEnabled, setOnlineEnabled] = useState(false);

  const load = useCallback(() => {
    if (!getAuthHeader().Authorization) return Promise.resolve();
    return axios.get(endpoints.settings, { headers: getAuthHeader() })
      .then((res) => {
        setClock(res.data.clock || null);
        setClockButton(res.data.clock_button || null);
        setOnlineEnabled(!!res.data.online_ordering_enabled);
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    load();
    const timer = setInterval(load, 30000);
    window.addEventListener("focus", load);
    return () => { clearInterval(timer); window.removeEventListener("focus", load); };
  }, [load]);

  return { clock, clockButton, onlineEnabled, refresh: load, blocked: !!(clock && clock.enforced && !clock.clocked_in) };
}
